'use strict';
import React, { PureComponent } from 'react';
import DatosGenerales from './DatosGenerales';
import DatosContables from './DatosContables';
import DatosMovimiento from './DatosMovimiento';


class ModalAltaEdicionRenglonContable extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.checkAperturaPorSocio) {
            this.props.seleccionarRbDefaultSocios();
        }
        //Cuando el modal se active, al ser de un largo extenso, se posiciona al inicio de la ventana para que pueda visualizarse el modal desde el inicio
        //y no desde el lugar del botón donde se activó
        window.scrollTo(0, 0);


        this.props.cargarInformacionTipoMovimientos(this.props.rbMarca);

    }

    render() {
        /* ACTIONS */
        const { 
            buscarCuentasContables,
            cambiarInputActivo,
            cambiarOpcionCombo,
            cambiarOpcionComboCriterios,
            cambiarValorInput,
            cargarInformacionTipoMovimientos,
            cargarInformacionComboImporte,
            cargarInformacionCriteriosContables,
            checkAperturaPorSocio,
            combosABMModelos,
            comboCentroDeCosto,
            comboCentroCostoSeleccionado,
            comboCampoImporte,
            comboCampoImporteSeleccionado,
            comboModalAltaEdicionRenglonContable,
            comboTipoMovimientoSeleccionado,
            contenedorCombosCriteriosContables,
            cuentasContablesFiltradas,
            cuentaSeleccionada,
            errorValidacion,
            elegirOpcionSelector,
            guardarValorInput,
            inputActivo,
            inputsAltaEdicionRenglonContable,
            inputsModal,
            limpiarMensajeErrorPorNombre,
            mostrarOcultarModalAltaEdicionRenglonContable,
            mostrarSpinnerModalRenglones,
            rbMarca,
            rbModalAltaEdicionRenglonContable,
            renglonEdicion,
            seleccionarRadioButtonABMModelos,
            setMostrarLinkVerMas,
            comboTiposMovimientos,
            validarGuardarModalAltaEdicionRenglon
         } = this.props

        return (
            <div className="modalContainer ABMModelos__modalAltaEdicionRenglon__modalPosition">
                <div className="ABMModelosModalAltaEdicionRenglon">
                    <div className="ABMModelosModalContainer__header">
                        <div className="ABMModelosModalContainer__contenedorTituloBoton">
                            <div className="ABMModelosModalContainer__titulo">
                                {JSON.stringify(renglonEdicion) != '{}' ? `Renglón contable N° ${renglonEdicion.NroRenglon} del modelo ${renglonEdicion.ModeloContableCabeceraId} - ${renglonEdicion.DescripcionRenglon}`
                                    :
                                "Nuevo renglón contable"}
                            </div>
                            <div className="ABMModelosModalContainer__botonCerrar" onClick={() => mostrarOcultarModalAltaEdicionRenglonContable("modalAltaEdicionRenglonContable", false)}></div>
                        </div>
                    </div>

                    <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoria ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoriaHeader"></div>

                    <div className="ABMModelosModalContainer__body ABMModelosModalContainer__modalAltaEdicionRenglonContableBody modalLogIntentosScroll ABMModelosModalAltaEdicionRenglon__bodyScroll">

                        <DatosGenerales
                            cambiarValorInput={cambiarValorInput}
                            limpiarMensajeErrorPorNombre={limpiarMensajeErrorPorNombre}
                            seleccionarRadioButtonABMModelos={seleccionarRadioButtonABMModelos}
                            errorValidacion={errorValidacion}
                            checkAperturaPorSocio={checkAperturaPorSocio}
                            inputsModal={inputsModal}
                            rbModalAltaEdicionRenglonContable={rbModalAltaEdicionRenglonContable}
                        />
                        <DatosContables 
                        buscarCuentasContables={buscarCuentasContables}
                        cambiarOpcionCombo={cambiarOpcionCombo}
                        cambiarInputActivo={cambiarInputActivo}
                        cambiarValorInput={cambiarValorInput}
                        comboCentroDeCosto={comboCentroDeCosto}
                        comboCentroCostoSeleccionado={comboCentroCostoSeleccionado}
                        cuentasContablesFiltradas={cuentasContablesFiltradas}
                        cuentaSeleccionada={cuentaSeleccionada}
                        errorValidacion={errorValidacion}
                        guardarValorInput={guardarValorInput}
                        inputActivo={inputActivo}
                        inputsAltaEdicionRenglonContable={inputsAltaEdicionRenglonContable}
                        rbModalAltaEdicionRenglonContable = {rbModalAltaEdicionRenglonContable}
                        seleccionarRadioButtonABMModelos = {seleccionarRadioButtonABMModelos}
                        
                        
                        />
                        {rbModalAltaEdicionRenglonContable.rbTipoRenglon == 1 ?
                        <DatosMovimiento
                        cambiarOpcionCombo={cambiarOpcionCombo}
                        cambiarOpcionComboCriterios={cambiarOpcionComboCriterios}
                        checkAperturaPorSocio = {checkAperturaPorSocio}
                        cargarInformacionTipoMovimientos = {cargarInformacionTipoMovimientos}
                        cargarInformacionComboImporte={cargarInformacionComboImporte}
                        cargarInformacionCriteriosContables={cargarInformacionCriteriosContables}
                        combosABMModelos={combosABMModelos}
                        comboCampoImporte = {comboCampoImporte}
                        comboCampoImporteSeleccionado = {comboCampoImporteSeleccionado}
                        comboModalAltaEdicionRenglonContable = {comboModalAltaEdicionRenglonContable}
                        comboTipoMovimientoSeleccionado = {comboTipoMovimientoSeleccionado}
                        contenedorCombosCriteriosContables = {contenedorCombosCriteriosContables}
                        errorValidacion={errorValidacion}
                        elegirOpcionSelector = {elegirOpcionSelector}
                        mostrarSpinnerModalRenglones={mostrarSpinnerModalRenglones}
                        rbMarca = {rbMarca}
                        rbModalAltaEdicionRenglonContable = {rbModalAltaEdicionRenglonContable}
                        seleccionarRadioButtonABMModelos = {seleccionarRadioButtonABMModelos}
                        setMostrarLinkVerMas = {setMostrarLinkVerMas}
                        comboTiposMovimientos = {comboTiposMovimientos}
                         />
                        : null }
                                

                    </div>

                    <div className="ABMModelosModalContainer__footer">
                        <div>
                            <button className="ABMModelosModalContainer__botonAceptar" onClick={() => validarGuardarModalAltaEdicionRenglon(renglonEdicion)}>
                                Aceptar
                            </button>
                        </div>

                        <div>
                            <button className="ABMModelosModalContainer__botonCancelar" onClick={() => mostrarOcultarModalAltaEdicionRenglonContable("modalAltaEdicionRenglonContable", false)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalAltaEdicionRenglonContable;